var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:[
    'asc-card',
    _vm.noSpacing ? 'asc-card--noSpacing' : '',
    _vm.flat ? 'asc-card--flat' : '',
    _vm.outlined ? 'asc-card--outlined' : '',
    _vm.dark ? 'asc-card--dark' : '',
    _vm.hover ? 'asc-card--hover' : '' ],attrs:{"flat":_vm.flat,"tile":_vm.tile,"outlined":_vm.outlined,"loading":_vm.loading,"loader-height":_vm.loaderHeight,"dark":_vm.dark,"hover":_vm.hover,"disabled":_vm.disabled}},[(_vm.hasTitleSlot)?_c('v-card-title',{staticClass:"asc-card__title"},[_c('div',[_vm._t("title")],2)]):_vm._e(),_c('v-card-text',{class:['asc-card__text', !_vm.hasTitleSlot ? 'asc-card__text-cover' : '']},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }